'use client';

import { MapProvider } from 'react-map-gl';

export default function MapGLProvider({ children }) {
  return <MapProvider>{children}</MapProvider>;
}
